import { useSyncExternalStore } from 'react';

const DOCUMENT_HASH_PATTERN = /^#document-(.+)$/;

const subscribe = (onChange: () => void) => {
  window.addEventListener('hashchange', onChange);
  return () => window.removeEventListener('hashchange', onChange);
};

const getSnapshot = () => window.location.hash;

/**
 * Reactively tracks the `#document-<id>` URL hash and returns the targeted document id (or null).
 *
 * Subscribes to the URL hash via `useSyncExternalStore` so the value can be read directly in render
 * (e.g. to drive `activeRowId`) without mirroring it into component state. Deep-link page-jump +
 * scroll is handled separately by `useDocumentHighlight`, which needs the table instance.
 */
export function useHashDocumentId(): string | null {
  const hash = useSyncExternalStore(subscribe, getSnapshot, () => '');
  return hash.match(DOCUMENT_HASH_PATTERN)?.[1] ?? null;
}
